import axios from "axios";

import { apiClient } from "@shared/http/apiClient";

export class DocumentError extends Error {}

function toDocumentError(error: unknown): DocumentError {
  if (!axios.isAxiosError(error)) {
    return new DocumentError("Couldn't upload the file.");
  }

  if (!error.response) {
    return new DocumentError(
      "Can't reach the server. Check your internet connection and try again."
    );
  }

  const status = error.response.status;

  if (status >= 400 && status < 500) {
    return new DocumentError("Couldn't upload the file. Check the matter and try again.");
  }

  return new DocumentError(`Couldn't upload the file (${status}). Try again in a moment.`);
}

export async function uploadMatterDocument(
  matterId: number,
  name: string,
  file: Blob
): Promise<void> {
  const formData = new FormData();
  formData.append("name", name);
  formData.append("file", file, name);

  try {
    await apiClient.post(`/v1/outlook/matters/${matterId}/documents`, formData);
  } catch (error) {
    throw toDocumentError(error);
  }
}
